import styled from "styled-components";

export const PermissionsEditorRoot = styled.div`
  flex-grow: 1;
  overflow: auto;
  padding: 1rem 0 2rem 0;
`;
